// What the key guide says over each page: its heading, the sections of
// the page's other views, and the keys its focused controls handle.

import { dashboardOffers } from '../commands/dashboard';
import { findFileListKeys, stackMapKeys, stackMenuKeys, tabListKeys, timelineHandleKeys, timelineMenuKeys, timelinePointKeys } from './controls';
import { PAGES, pageSections, SCOPES } from './bindings';
import type { GuideSpec } from './router';

/** The sections of every view of a pull request, and of the comment boxes over them: what its guide lists beside the view shown. */
const PR_SECTIONS = [...new Set([...Object.keys(PAGES).filter((page) => PAGES[page].includes('pullRequest')).flatMap(pageSections), ...SCOPES.field.sections])];

/** The guide over the pull request pages. */
export const PR_GUIDE: GuideSpec = {
  heading: 'Move through the review',
  intro: 'One grammar on every view: select, then act. Keys work outside text inputs (`Esc` leaves one) and embedded pages (click outside one to come back).',
  related: PR_SECTIONS,
  controls: [timelinePointKeys, timelineHandleKeys, timelineMenuKeys, findFileListKeys, tabListKeys, stackMenuKeys],
};

/** The guide over the dashboard: what it has something for, since no other view's keys work there. */
export const DASH_GUIDE: GuideSpec = {
  heading: 'Move through the dashboard',
  intro: 'Keys work outside text inputs (`Esc` leaves one). The row the keys work from is ringed while the list has the focus.',
  related: [],
  controls: [stackMapKeys],
  offers: dashboardOffers,
};
